import { DEFAULT_MENU_FACTORY_UID, MenuDefinition, MenuItemInsertion, Page, PageDefinition, PageDefinitions } from "@cervval.js/client-html5-spa/navigation";
import { PermissionString } from "@cervval.js/common-permissions";
import { objectKeys } from "@cervval.js/common/src/tools/object.tools";
import { ObjectTools } from "@cervval.js/common/tools";
import { agendaPages } from "./pages/agenda/agendaPage.pages";
import { proBookingPages } from "./pages/booking/bookingPage.pages";
import { mapPages } from "./pages/map/interactiveMap.pages";
import { productsPages } from "./pages/products/productPage.pages";
import { profilePages } from "./pages/profile/profile.pages";


export const bookingMenus = {
    "bookingMenu": ObjectTools.is<MenuDefinition>({
        menuFactoryUid: DEFAULT_MENU_FACTORY_UID,
        sections: {
            mainSection: "mainSection"
        }
    }),
    "proMenu": ObjectTools.is<MenuDefinition>({
        menuFactoryUid: DEFAULT_MENU_FACTORY_UID,
        sections: {
            mainSection: "mainSectionPro"
        }
    })
};
/**
 * Module pages by pageName
 */
export const bookingPages: PageDefinitions = {
    ...mapPages,
    ...profilePages,
    ...agendaPages,
    ...proBookingPages,
    ...productsPages
};

export type BookingPageName = keyof typeof bookingPages;

/** */
export function getBookingPages<MenuUid extends string>(options?: { menus?: MenuItemInsertion<MenuUid>[], function: { pagename: string, importPromise?: () => Promise<Page> } }): Record<keyof typeof bookingPages, PageDefinition<MenuUid, PermissionString>> {
    const pages = bookingPages;

    if (options?.menus) {
        for (const pageName of objectKeys(pages)) {
            pages[pageName].menus = options.menus;
        }
    }

    if (options?.function.importPromise) {
        for (const pageName of objectKeys(pages)) {
            if (options.function.pagename === pageName) {
                pages[pageName].importPromise = options.function.importPromise;
            }
        }
    }

    return pages as ReturnType<typeof getBookingPages<MenuUid>>;
}